import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faXmark } from "@fortawesome/free-solid-svg-icons";


const PasswordRuleChecker = ({ flag, content }) => {

  switch (flag) {
    case true:
      return (
        <>
          <FontAwesomeIcon icon={faCheck} className='text-success passwordMeterIcon'></FontAwesomeIcon>
          &nbsp;
          {content}
        </>
      );
    case false:
      return (
        <>
          <FontAwesomeIcon icon={faXmark} className='text-danger passwordMeterIcon'></FontAwesomeIcon>
          &nbsp;
          {content}
        </>
      );
    default:
      return (
        <>
          <FontAwesomeIcon icon={faXmark} className='text-danger invisible passwordMeterIcon'></FontAwesomeIcon>
          &nbsp;
          {content}
        </>
      )

  }

  // {passwordChecker.lengthCheck ?
  //   <FontAwesomeIcon icon={faCheck} style={{ color: "green" }}></FontAwesomeIcon>
  //   :
  //   <FontAwesomeIcon icon={faXmark} style={{ color: "red" }}></FontAwesomeIcon>
  // }

}

export default PasswordRuleChecker;